import ServiceApi from "@mrg_minigames/common/helpers/api/ServiceApi";

class CollectionApi extends ServiceApi {
  constructor() {
    super("minigameCollection", "collection");
  }

  getProgress(activity_key) {
    return this.request("getProgress", {
      activityKey: activity_key,
    });
  }

  joinActivity(activity_key) {
    return this.request("join", {
      activityKey: activity_key,
    });
  }

  drawCard(activity_key) {
    return this.request("open", {
      activityKey: activity_key,
    });
  }

  drawCardAll(activity_key) {
    return this.request("openAll", {
      activityKey: activity_key,
    });
  }

  upgradeCards(activity_key, level) {
    return this.request("upgrade", {
      activityKey: activity_key,
      level: level,
    });
  }

  claimReward(activity_key, level) {
    return this.request("claim", {
      activityKey: activity_key,
      level: level,
    });
  }
}
export default new CollectionApi();
